var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"page"}},[_c('Head',{attrs:{"headTitle":_vm.headTitle}}),_c('div',{staticClass:"container",attrs:{"id":"map_container"}}),_c('div',{staticClass:"info",staticStyle:{"min-width":"18rem"},attrs:{"id":"tip"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }